import { createFileRoute, redirect } from '@tanstack/react-router';
import { WbsDetailsManagement } from '../components/WbsDetailsManagement';
import { isAdmin } from '../utils/roles';

export const Route = createFileRoute('/settings/wbs-details')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!isAdmin(user?.role)) {
      throw redirect({
        to: '/project-settings/employee-project-models',
      });
    }
  },
  component: WbsDetailsSettingsComponent,
});

function WbsDetailsSettingsComponent() {
  return <WbsDetailsManagement />;
}
